/* global d3 $ _ */

import pipeService from "../../service/pipeService";
import dataService from "../../service/dataService";
import "../../assets/wordFreqBarChart.css"


// Compute if shap hits qc in questions. 
function shap_hit_qc(qc, stem, shap_positions) {
    let hit = false
    // console.log("Computing shap hit qc: ", qc, stem, shap_positions)
    // Delete multiple spaces and replace space with '_'
    stem = stem.replace(/\s{2,}/g, ' ')
    let all_qc_pos = [];
    let before_length = 0;
    stem = stem.replaceAll(' ', '').toLowerCase()
    qc = qc.replaceAll('_', '').toLowerCase()
    // console.log("STEM: ", stem, "qc", qc)
    while (stem.indexOf(qc) != -1) {
        var pos = stem.indexOf(qc) 
        all_qc_pos.push(pos + before_length)
        before_length += pos + qc.length
        if (pos + qc.length >= stem.length) {
            break
        }
        stem = stem.substring(pos + qc.length, stem.length)
    }
    if (all_qc_pos.length === 0) {
        // console.log("Shap hit: ", hit)
        return false;
    }
    // console.log(all_qc_pos)
    shap_positions.forEach((v, i) => {
        // console.log("pos", v[0], v[2])
        if (all_qc_pos.includes(v[2]) ) {
            hit = true;
        }
    })
    // console.log("Shap hit: ", hit)
    return hit
}

// Handle filter only qc hit or not hit questions:
function handleHitRectClick(d) {
    if (!d3.select(this).classed("selected")) {
        d3.select(this)
           .style('stroke', 'black')
           .classed("selected", true)
   } else {
       d3.select(this)
           .style('stroke', 'white')
           .classed("selected", false);
   }

    console.log(this.id, d)
    let thisClass = document.getElementById(this.id).className.baseVal
    console.log(thisClass)
    if (thisClass == "selected") {
        if (this.id === 'qcHitRect') {
            console.log("Only correct selected. ")
            d3.select("#qcNotHitRect")
                .style('stroke', 'white')
                .classed("selected", false);
            pipeService.emitSelectOnlyQcHit('only_hit')
        } else if (this.id === 'qcNotHitRect') {
            d3.select("#qcHitRect")
                .style('stroke', 'white')
                .classed("selected", false);
            pipeService.emitSelectOnlyQcHit('only_not_hit')
        }
        d3.select("#correctRect")
            .style('stroke', 'white')
            .classed("selected", false);
        d3.select("#wrongRect")
            .style('stroke', 'white')
            .classed("selected", false);
   } else {
       console.log("Only qc hit or not hit unselected. ")
       pipeService.emitSelectOnlyQcHit('unselected')
   }

   // hit click event
   let hit = true;
   if(this.id === 'qcHitRect'){
    hit = true;
   }else if(this.id === 'qcNotHitRect'){
    hit = false;
   }
   let target_info = {"view": "instance_view", "target": "hit_bars"}
   let additional_info = {"hit": hit}
   dataService.saveUserDataWrapper("click", target_info, additional_info);
   
}


// Handle rect on click selected;
function clickAccuracy(d) {   
    if (!d3.select(this).classed("selected")) {
         d3.select(this)
            .style('stroke', 'black')
            .classed("selected", true)
    } else {
        d3.select(this)
            .style('stroke', 'white')
            .classed("selected", false);
    }

    console.log(this.id, d)
    let thisClass = document.getElementById(this.id).className.baseVal
    console.log(thisClass)
    if (thisClass == "selected") {
        if (this.id === 'correctRect') {
            console.log("Only correct selected. ")
            d3.select("#wrongRect")
                .style('stroke', 'white')
                .classed("selected", false);
            pipeService.emitSelectOnlyTrueFalse('only_true')
            
        } else if (this.id === 'wrongRect') {
            d3.select("#correctRect")
                .style('stroke', 'white')
                .classed("selected", false);
            pipeService.emitSelectOnlyTrueFalse('only_false')
        }
        d3.select("#qcHitRect")
            .style('stroke', 'white')
            .classed("selected", false);
        d3.select("#qcNotHitRect")
            .style('stroke', 'white')
            .classed("selected", false);
    } else {
        console.log("Only correct or wrong unselected. ")
        pipeService.emitSelectOnlyTrueFalse('unselected')
    }

    // acc_bars hover event
    let correctness = true;
    if (this.id === 'correctRect') {
        correctness = true;
    }else if(this.id === "wrongRect"){
        correctness = false;
    }
    let target_info = {"view": "instance_view", "target": "acc_bars"}
    let additional_info = {"correctness": correctness}
    dataService.saveUserDataWrapper("click", target_info, additional_info);    
    

    
}

let DrawSearchStats = function(containerIdDict) {
    this.containerIdDict = containerIdDict
    
    this.accWidth = $('#' + this.containerIdDict.accuracy).width()
    this.accHeight = $('#' + this.containerIdDict.accuracy).height()
    this.accMargin = { top: 22, right: 15, bottom: 13, left: 5}

    this.hitWidth = $('#' + this.containerIdDict.modelHit).width()
    this.hitHeight = $('#' + this.containerIdDict.modelHit).height()
    this.hitMargin = { top: 13, right: 15, bottom: 22, left: 5}

    this.freqWidth = $('#' + this.containerIdDict.wordFreq).width()
    this.freqHeight = $('#' + this.containerIdDict.wordFreq).height()
    this.freqMargin = { top: 10, right: 15, bottom: 65, left: 5}

}

DrawSearchStats.prototype.layout = function(data, filterStopWords) {
    let wrongColor = "#DDDDDD" // Red: #FF4A4A
    let correctColor = "#93C47D" // Green "#93C47D"

    console.log("Search Statistics input data: ")
    console.log(data) 

    if (Object.entries(data).length === 0) {
        d3.select("#" + this.containerIdDict.accuracy + "_svg").remove()
        d3.select("#" + this.containerIdDict.modelHit + "_svg").remove()
        d3.select("#" + this.containerIdDict.wordFreq + "_svg").remove()
        console.log("Searhed empty, clear stats. ")
        return;
    }

    let acc = data.filter(d => d.is_correct).length / data.length
    console.log("Searched group accuracy", acc)
    let hitRatioList = []
    for (const d of data) {
        hitRatioList.push( shap_hit_qc(d.question_concept, d.raw_question['question']['stem'], d.shap_concept_positions) )
        // let union = Array.from(new Set([...d.conceptnet_concepts, ...d.shap_concepts]));
        // hitRatioList.push(d.shap_concepts.length / union.length)
    }
    // computer average shap hit qc ratio
    let hitRatio = hitRatioList.reduce((a, b) => a + b, 0) / hitRatioList.length;
    console.log("Searched group average hit ratio", hitRatio)
    
    // Draw Accuracy
    let accContainer = this.containerIdDict.accuracy
    // append the svg object to the body of the page
    d3.select("#" + accContainer + "_svg").remove()
    var accSvg = d3.select("#" + accContainer)
        .append("svg")
        .attr("id", accContainer + "_svg")
        .attr("width", this.accWidth)
        .attr("height", this.accHeight)
        .append("g")
        .attr("transform", "translate(" + this.accMargin.left + "," + this.accMargin.top + ")");
    
    let accFullWidth = this.accWidth - this.accMargin.left - this.accMargin.right
    let accHeight = this.accHeight - this.accMargin.top - this.accMargin.bottom
    
    accSvg.append('rect')
        .attr('id', 'correctRect')
        .attr("width", accFullWidth * acc)
        .attr("height", accHeight)
        .attr("fill", correctColor)
        // .style("stroke", (d) => (d.selected) ? "#000000":"#ffffff")
        .on("click", clickAccuracy)
        .on('mouseover', function (d) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '.7');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", ".7");
            hoverDiv.html("Accuracy: " + acc.toFixed(3).toString())
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 35) + "px");

            // acc_bars hover event
            let target_info = {"view": "instance_view", "target": "acc_bars"}
            let additional_info = {"correctness": true}
            dataService.saveUserDataWrapper("hover", target_info, additional_info);    
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '1');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", 0);
        })
       
    accSvg.append('rect')
        .attr('id', 'wrongRect')
        .attr("x", accFullWidth * acc + 1)
        .attr("width", accFullWidth - accFullWidth * acc)
        .attr("height", accHeight)
        .attr("fill", wrongColor)  
        .on("click", clickAccuracy)
        .on('mouseover', function (d) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '.7');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", ".7");
            hoverDiv.html("Accuracy: " + acc.toFixed(3).toString())
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 35) + "px");

            // acc_bars hover event
            let target_info = {"view": "instance_view", "target": "acc_bars"}
            let additional_info = {"correctness": false}
            dataService.saveUserDataWrapper("hover", target_info, additional_info);    
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '1');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", 0);
        })



    // Draw model hit
    let hitContainer = this.containerIdDict.modelHit
    // append the svg object to the body of the page
    d3.select("#" + hitContainer + "_svg").remove()
    var hitSvg = d3.select("#" + hitContainer)
        .append("svg")
        .attr("id", hitContainer + "_svg")
        .attr("width", this.hitWidth)
        .attr("height", this.hitHeight)
        .append("g")
        .attr("transform", "translate(" + this.hitMargin.left + "," + this.hitMargin.top + ")");
    
    let hitFullWidth = this.hitWidth - this.hitMargin.left - this.hitMargin.right
    let hitHeight = this.hitHeight - this.hitMargin.top - this.hitMargin.bottom
    hitSvg.append('rect')
        .attr('id', 'qcHitRect')
        .attr("width", hitFullWidth * hitRatio)
        .attr("height", hitHeight)
        .attr("fill", "#7FBCD2")
        .on("click", handleHitRectClick)
        .on('mouseover', function (d) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '.7');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", ".7");
            hoverDiv.html("Average QC Hit Ratio: " + hitRatio.toFixed(3).toString())
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 35) + "px");

            // hit hover event
            let target_info = {"view": "instance_view", "target": "hit_bars"}
            let additional_info = {"hit": true}
            dataService.saveUserDataWrapper("hover", target_info, additional_info); 
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '1');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", 0);
        })

    hitSvg.append('rect')
        .attr('id', 'qcNotHitRect')
        .attr("x", hitFullWidth * hitRatio + 1)
        .attr("width", hitFullWidth - hitFullWidth * hitRatio)
        .attr("height", hitHeight)
        .attr("fill", wrongColor)
        .on("click", handleHitRectClick)
        .on('mouseover', function (d) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '.7');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", ".7");
            hoverDiv.html("Average QC Hit Ratio: " + hitRatio.toFixed(3).toString())
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 35) + "px");

            // hit hover event
            let target_info = {"view": "instance_view", "target": "hit_bars"}
            let additional_info = {"hit": false}
            dataService.saveUserDataWrapper("hover", target_info, additional_info); 
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '1');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", 0);
        })


    // Draw frequency bar chart. 
    let freqContainer = this.containerIdDict.wordFreq
    let freqFullWidth = this.freqWidth - this.freqMargin.left - this.freqMargin.right
    let freqHeight = this.freqHeight - this.freqMargin.top - this.freqMargin.bottom


    
    let minBarHeight = 1
    let topN = 20
    let barWidth = freqFullWidth / topN
    let barFillColor = "#7FBCD2"

    // append the svg object to the body of the page
    d3.select("#" + freqContainer + "_svg").remove()
    var freqSvg = d3.select("#" + freqContainer)
        .attr("transform", "translate(" + this.freqMargin.left + "," + this.freqMargin.top + ")")
        .append("svg")
        .attr("id", freqContainer + "_svg")
        .attr("width", barWidth * topN + 10)
        .attr("height", this.freqHeight)
        .append("g")
        .attr("id", freqContainer + "_svg_group")
        .attr("transform", "translate(" + this.freqMargin.left + "," + this.freqMargin.top + ")");
    

    let wordFreqs = []
    let maxFreq = 0
    let wordList = []
    for (const q of data) {
        wordList.push(...q.shap_concepts)
    }
    // console.log(wordList)
    let wordCntDict = {}
    wordList.forEach((w, i) => {topN
        if (wordCntDict.hasOwnProperty(w)) {
            wordCntDict[w] += 1
        } else {
            wordCntDict[w] = 1
        }
    })
    // console.log(wordCntDict)
    // Create items array
    var words = Object.keys(wordCntDict).map(function(key) {
        return [key, wordCntDict[key]];
    });
    // Sort the array based on the second element
    words.sort(function(first, second) {
        return second[1] - first[1];
    });


    let stopWordList = ["ourselves", "hers", "between", "yourself", "but", "again", "there", "about", "once", "during", "out", 
    "very", "having", "with", "they", "own", "an", "be", "some", "for", "do", "its", "yours", "such", "into", "of", "most", 
    "itself", "other", "off", "is", "s", "am", "or", "who", "as", "from", "him", "each", "the", "themselves", "until", 
    "below", "are", "we", "these", "your", "his", "through", "don", "nor", "me", "were", "her", "more", "himself", 
    "this", "down", "should", "our", "their", "while", "above", "both", "up", "to", "ours", "had", "she", "all", 
    "no", "when", "at", "any", "before", "them", "same", "and", "been", "have", "in", "will", "on", "does", 
    "yourselves", "then", "that", "because", "what", "over", "why", "so", "can", "did", "not", "now", "under", 
    "he", "you", "herself", "has", "just", "where", "too", "only", "myself", "which", "those", "i", "after", 
    "few", "whom", "t", "being", "if", "theirs", "my", "against", "a", "by", "doing", "it", "how", "further", "was", "here", "than"]
    // console.log("Words before: ", words)
    // Filter stop words or not 
    if (filterStopWords) {
        words = words.filter(w => {
            // console.log(w, !stopWordList.includes(w[0]));
            return !stopWordList.includes(w[0]);
        })
    }

    // console.log("Words after: ", words)
    if (words.length > 0) {
        maxFreq = words[0][1]
    }
    if (words.length > topN) {
        words = words.slice(0, topN)
    } else {
        topN = words.length
    }

    words.forEach((w, i) => {
        wordFreqs.push({
            "id": i, 
            "text": w[0],
            "freq": w[1], 
        })
    })
    // console.log("Word Frequencies: ", wordFreqs)

    
    // X axis
    var x = d3.scaleBand()
        .range([0, barWidth * wordFreqs.length])
        .domain(wordFreqs.map(d => d.id))
        .padding(0.1);
    console.log(x(1), x(2))
    // freqSvg.append("g")
    //     .attr("transform", "translate(0," + height + ")")
    //     .call(d3.axisBottom(x))
    //     .selectAll("text")
    //     .attr("transform", "translate(-10,0)rotate(-45)")
    //     .style("text-anchor", "end");

    // Add Y axis
    var y = d3.scaleLinear()
        .domain([0, maxFreq])
        .range([ freqHeight, 0]);
    // svg.append("g")
    //     .call(d3.axisLeft(y));

    d3.select('#barTooltip').remove()
    var hoverDiv = d3.select("body").append("div")
        .attr("class", "tooltip")
        .attr("id", "barTooltip")
        .style("opacity", 0)


    // Bars
    freqSvg.selectAll("mybar")
        .data(wordFreqs)
        .enter()
        .append("rect")
        .attr("x", function(d, i) { 
            // console.log(i, d, x(i)); 
            return x(i); })
        .attr("y", function(d) { 
            if (freqHeight - y(d.freq) < minBarHeight) { return freqHeight - minBarHeight; }
            else { return y(d.freq); }
        })
        .attr("width", x.bandwidth())
        .attr("height", function(d) { 
            if (freqHeight - y(d.freq) < minBarHeight) { return minBarHeight; }
            else { return freqHeight - y(d.freq); }
        })
        .attr("fill", barFillColor)
        .on('mouseover', function (d) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '.6');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", ".7");
            hoverDiv.html("Word: " + d.text + "<br/>Frequency: " + d.freq.toString())
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 75) + "px");
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '1');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", 0);
        })

    let wordTextGroup =  d3.select("#" + freqContainer + "_svg")
        .append("g")
        .attr("id", freqContainer + "_text_group")
        .attr("transform", "translate(" + this.freqMargin.left + "," + (this.freqMargin.top + this.freqHeight - this.freqMargin.bottom) + ")");
    // wordTextGroup.append('rect')
    //     .attr("width", 300)
    //     .attr("height", 30)
    //     .attr("fill", '#FF4A4A') 
    wordTextGroup.selectAll("myWordText")
        .data(wordFreqs)
        .enter()
        .append("text")
        // .attr("x", function(d, i) { return x(i); })
        // .attr("y", this.freqMargin.bottom)
        // .attr("class", "word-text")

        .attr("transform", function(d, i) { return "translate(" + (x(i) + barWidth / 4) + "," + 33 + ")" + " rotate(-60)"; })
        // .attr("transform", "rotate(-45deg)")
        .text(function(d, i) { return d.text;})
        .style("font-weight", "100")
        .style("font-size", "12px")
        // .append('title')
        // .text((d) => `Word: ${d.text} Frequency: ${d.freq}`)
        

    

}

export default DrawSearchStats
